import { createTypes } from 'reduxsauce';



export default createTypes(`
    
    ADD_STUDENT_CONTENT_ID
    UPDATE_STUDENT

    STORE_MESSAGE_FROM
    STORE_MESSAGES

    SEND_MESSAGE
    FETCH_MESSAGES
    FETCH_MESSAGE_FROM
    FETCH_MESSAGE_RECEIVERS

    FETCH_MESSAGE_UNREAD_COUNT
    STORE_MESSAGE_UNREAD_COUNT

    UPDATE_ALERTS
    FETCH_ALERTS
    STORE_ALERTS

    FETCH_VACCINATION_V2
    RESPONSE_VACCINATION

    FETCH_LATEST_GROWTH_OVERVIEW
    STORE_LATEST_GROWTH_OVERVIEW
    
    FETCH_NURSE_META
    STORE_NURSE_META

    LOGIN_USING_MAGIC_LINK
    LOGIN_RESPONSE_MAGIC_LINK
    
    FETCH_CLINIC_EPISODE_STATS
    STORE_CLINIC_EPISODE_STATS

    FETCH_CLINIC_STUDENT_SEARCH
    STORE_CLINIC_STUDENT_SEARCH

    FETCH_STUDENT_EPISODE_SEARCH
    STORE_STUDENT_EPISODE_SEARCH

    ADD_SCHOOL_CONTENT_ID
    
    POST_STUDENT_EPISODE_INFO
    TOGGLE_DATA_UPDATE_FLAG
    
    ADD_STUDENT_MEDICAL_INFO
    FETCH_CUSTOM_STUDENT_LIST

    GET_SCHOOL_CLASSES
    
    EXAMPLE
    LOGIN_USER
    LOGIN_RESPONSE
    LOGOUT_USER
    CHANGE_PASSWORD

    INITIALIZE_FORM
    GET_ORGANIZATION
    STORE_ORGANIZATION
    PUT_ORGANIZATION
    STORE_CLASSES

    FETCH_STUDENT_LIST
    STORE_STUDENT_LIST

    GET_PROGRAM_BY_ORGANIZATION
    STORE_PROGRAM_LIST

    GET_REPORT
    LOAD_REPORT

    GET_STUDENT_REPORT
    LOAD_STUDENT_REPORT
    GET_BULK_STUDENT_REPORT
    RESET_STUDENT
    RESET_ORG

    SET_LOADER
    UNSET_LOADER

    FETCH_ALL_DOCS
    UPDATE_DOCS
    REMOVE_DOC
    UPLOAD_FILE

    FETCH_OVERVIEW_REPORT
    STORE_OVERVIEW_REPORT

    GET_GLOSSARY
    STORE_GLOSSARY
    
    GET_DMFT_INDEX
    UPDATE_DMFT_INDEX

    CHANGE_REPORT_IN_REDUCER
    
`)


// WEBPACK FOOTER //
// ./src/Actions/Types.js